import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";

import tmdbApi from "../../api/tmdbApi";

const VideoList = ({ id }) => {
  const { category } = useParams();
  const [trailers, setTrailers] = useState([]);

  useEffect(() => {
    const getVideos = async () => {
      try {
        const response = await tmdbApi.getVideos(category, id);
        // Only include YouTube trailers
        const filtered = response.results.filter(
          (v) => v.site === "YouTube" && v.type === "Trailer"
        );
        setTrailers(filtered.slice(0, 5));
      } catch (err) {
        console.error(err);
      }
    };
    getVideos();
  }, [category, id]);

  return (
    <div className="trailers">
      {trailers.map((item, index) => (
        <TrailerVideo key={index} item={item} />
      ))}
    </div>
  );
};

const TrailerVideo = ({ item }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const height = (iframeRef.current.offsetWidth * 9) / 16 + "px";
    iframeRef.current.setAttribute("height", height);
  }, []);

  return (
    <div className="video">
      <div className="video__title">
        <h2>{item.name}</h2>
      </div>
      <iframe
        src={`https://www.youtube.com/embed/${item.key}`}
        ref={iframeRef}
        width="100%"
        title="trailer_video"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VideoList;
